import { registerView, View, ViewComponent } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import React from "react";
import { useCallback } from "react";
import { Col, Form, Row } from "react-bootstrap";
import LicenseViewModel from "viewModels/eshop/order/steps/licenseViewModel";
import LoadingPane from "controls/loadingPane";
import AlertWithInfoIcon from "views/common/alertWithInfoIcon/alertWithInfoIcon";
import ElectricVehicleExemptionAlert from "views/common/electricVehicleExemptionAlert/electricVehicleExemptionAlert";
import { StepsNavigationButtons } from "../components/stepsNavigationButtons";

const LicenseView: ViewComponent<LicenseViewModel> = observer(({ vm }) => {
  const tg = (value: string) => vm.localizationService.translateGeneral(`eshop.order.${value}`);
  const translate = (value: string) => vm.localizationService.translateGeneral(`eshop.order.license.${value}`);
  localStorage.removeItem("orderReloaded");
  const formRef = useCallback(node => {
    if (node !== null) {
      vm.formElement = node;
    }
  }, []);

  return (
    <>
      <div>
        <Form ref={formRef}>
          <View vm={vm.vehicleInfoViewModel} />
        </Form>
        {vm.hasElectricVehicleExemption && (
          <ElectricVehicleExemptionAlert
            title={vm.electricVehicleExemptionTitle}
            description={vm.electricVehicleExemptionDescription}
            highlightText={translate("electricVehicleExemption.highlight")}
          />
        )}
        {vm.exemptionReasonWarnings?.map((reason, index) => {
          return (
            <AlertWithInfoIcon key={index} variant="warning">
              <span>{vm.translateExemptionReasonWarnings(reason)}</span>
            </AlertWithInfoIcon>
          );
        })}
      </div>
      {!vm.loading ? (
        <StepsNavigationButtons tg={tg} onContinue={() => vm.onContinue()} />
      ) : (
        <Row className="d-flex align-items-center justify-content-center pt-4 pt-lg-4 pt-xl-4">
          <Col sm={1} lg="auto" className="p-2">
            <LoadingPane />
          </Col>
          <Col sm={4} lg="auto" className="p-2">
            <div className="d-flex align-items-center justify-content-center">{translate("chargeInstructions")}</div>
          </Col>
        </Row>
      )}
    </>
  );
});

registerView(LicenseView, LicenseViewModel);
